import moment from 'moment';

const prepareForEdit = (charterRequestDetail, isABid) => {
    let { client, clientDepartment, clientStaff, supplier, route, request, bids, bid, id } = { ...charterRequestDetail };
    const qGov = client?.clientType?.includes('QGov');
    const routes = route?.map((x, i) => {
        var date = moment(x.departTime);
        const newRoute = {
            ...x
            , viewDepartTime: date
            , viewDepartDate: new Date(x.departTime)
            , passengerRange: x.passengerRange_Max !== x.passengerRange_Min
            , passengerRange_Max: x.passengerRange_Max ? x.passengerRange_Max : x.passengerNumber
            , passengerRange_Min: x.passengerRange_Min ? x.passengerRange_Min : x.passengerNumber
            , routeId: x.id
            , share: x.share ? { ...x.share, enabled: true } : {
                enabled: false, seatsAvailable: 0, totalWeightAvailable: 0, costPerSeat: 0,
            }
        }
        var rbid = bid && bid.routes && bid.routes.length && bid.routes.find(y => {
            return y.routeId === x.id
        });
        const { manifest, ...br } = rbid ? rbid : {};
        return { ...newRoute, ...br, id: x.id };
    })

    const originalManifest = routes.length && routes[0].manifest ? routes[0].manifest : [];
    request.shareManifest = true;
    for (var i = 1; i < routes.length; i++) {
        const checkManifest = routes[i].manifest;
        if (checkManifest.length !== originalManifest.length) {
            request.shareManifest = false;
            break;
        }
        for (var j = 0; j < routes[i].manifest.length; j++) {
            if (checkManifest[j].passengerName !== originalManifest[j].passengerName ||
                checkManifest[j].contactNumber !== originalManifest[j].contactNumber ||
                checkManifest[j].emailAddress !== originalManifest[j].emailAddress ||
                checkManifest[j].passengerWeight !== originalManifest[j].passengerWeight ||
                checkManifest[j].freightWeight !== originalManifest[j].freightWeight ||
                checkManifest[j].cargoWeight !== originalManifest[j].cargoWeight) {
                request.shareManifest = false;
                break;
            }
        }
    }


    request.client = client;
    request.clientDepartment = clientDepartment;
    request.clientStaff = clientStaff;
    request.bids = bids;
    request.qGov = qGov;
    request.bid = bid;
    request.routes = routes;
    const tid = isABid ? bid.id : request.id;
    const newStatus = isABid ? bid.status : request.status;
    const newBid = bid ? { ...bid, withMargin:  bid.price > bid.withMargin ? bid.price+bid.withMargin : bid.withMargin } : null;
  
    return {
        client, clientDepartment, clientStaff,supplier,
        request: { ...request, id },
        ...request,
        ...newBid,
        jobReference: request.jobReference,
        bidderId: supplier ? supplier.id : bid ? bid.bidderId : null,
        routes: routes,
        id: tid,
        status: newStatus,
        isCharterRequest: true,
        charterRequestId: request.id
    };

}

export default prepareForEdit;